<script setup lang="ts">
import type {PropType} from 'vue'
import {ref, watch} from 'vue';
import type {MenuItem} from '../types/types.d.ts'


const props = defineProps({
  data: {
    type: Array as PropType<MenuItem[]>,
    required: true
  }
})

const menuDatas = ref(props.data as MenuItem[]);
watch(() => props.data, () => {
  menuDatas.value = props.data
})

</script>

<template>
  <div class="menu" v-loading="menuDatas.length == 0">
    <div class="menu-title" v-for="item in menuDatas" :key="item.id">
      <div class="text-bg" :class="{
        search: item.path==='/search'
      }">
        <router-link :to="item.path" class="menu-cate font-xbs">
          <span>{{ item.name }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.menu {
  display: flex;
  align-items: center;
}
.menu-title {
  cursor: pointer;
}

.cate-logo {
  width: 35px;
  height: 35px;
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.cate-title {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  font-size: 18px;
}

.cate-item-header {
  height: 45px;
  margin: 2px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 5px;
  border: 2px solid #ffffff00;
}

/* 丑的一批，之后再改 */
.cate-item-header:hover {
  border: 2px solid #f59009;
  border-radius: 0.8rem;
}

.menu-more-div {
  /* padding: 10px; */
  position: absolute;
  width: 160px;
  top: 25px;
  left: 55px;
  box-shadow: 1.2px 1.3px 2.2px rgba(0, 0, 0, 0.02),
  2.8px 3.2px 5.3px rgba(0, 0, 0, 0.028),
  5.3px 6px 10px rgba(0, 0, 0, 0.035),
  9.4px 10.7px 17.9px rgba(0, 0, 0, 0.042),
  17.5px 20.1px 33.4px rgba(0, 0, 0, 0.05),
  42px 48px 80px rgba(0, 0, 0, 0.07);
  z-index: 999;
  background-color: white;
  border-radius: 5px;
  display: none;
}

.sbar {

  height: 40px;

  border-radius: 0.8rem;
  border: 1px solid #f59009;
  overflow: hidden;

  .el-input__wrapper {
    box-shadow: none;
  }

  .el-input__wrapper.is-focus {
    box-shadow: none;
  }

  .el-input-group__append {
    box-shadow: none;
    background-color: #f59009;
    color: white;
  }
}

.menu-more {
  cursor: pointer;
  margin-left: 5px;
}

.menu {
  width: 80%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 45px 0;
  /* z-index: 99999;
  background-color: white; */
}

.menu-cate {
  display: flex;
  position: relative;
  color: black !important;
  font-size: 24px;
  text-decoration: none;
}

.text-bg {
  position: relative;

  // &:before {
  //   content: '';
  //   position: absolute;
  //   background: linear-gradient(to right, #f59009, 20%, #ffffff 70%);
  //   width: 100%;
  //   height: 18px;
  //   top: 6px;
  // }

  &.search {
    font-size: 24px;
    cursor: pointer;
    font-weight: 300;
    height: 26px;

    &:before {
      display: none;
    }

    .menu-cate {
      border-bottom: 1px solid #f59009;
      padding-bottom: 6px;
    }
  }
}

.menu-more:hover + .menu-more-div,
.menu-more-div:hover {
  display: block;
}
</style>